
<div class="space-y-6">
  <div>
    <h1 class="text-2xl font-bold text-gray-800 flex items-center gap-2">
      <i class="fa-solid fa-handshake text-indigo-600"></i> {{ 'backOffice.partnerNetwork.title' | translate }}
    </h1>
    <p class="text-gray-600 mt-1">{{ 'backOffice.partnerNetwork.subtitle' | translate }}</p>
  </div>

  <div class="bg-white rounded-md shadow-sm overflow-hidden">
    <div class="p-6">
        
        <!-- Status Indicator (Replaces Toggle Buttons) -->
        <div class="flex justify-center mb-8">
            <span class="px-4 py-1.5 rounded-full text-sm font-bold border flex items-center gap-2"
                  [class.bg-indigo-50]="userMode() === 'PROVIDER'"
                  [class.text-indigo-700]="userMode() === 'PROVIDER'"
                  [class.border-indigo-200]="userMode() === 'PROVIDER'"
                  [class.bg-emerald-50]="userMode() === 'CLIENT'"
                  [class.text-emerald-700]="userMode() === 'CLIENT'"
                  [class.border-emerald-200]="userMode() === 'CLIENT'">
                
                @if(userMode() === 'PROVIDER') {
                    <i class="fa-solid fa-user-doctor"></i> {{ 'backOffice.partnerNetwork.providerMode' | translate }}
                } @else {
                    <i class="fa-solid fa-cannabis"></i> {{ 'backOffice.partnerNetwork.clientMode' | translate }}
                }
            </span>
        </div>

        @if(userMode() === 'PROVIDER') {
            <!-- PROVIDER VIEW (CLINIC) -->
            <div class="space-y-8">
                <div class="bg-indigo-900 text-white p-6 rounded-xl text-center relative overflow-hidden">
                    <div class="relative z-10">
                        <p class="text-indigo-200 text-sm font-bold uppercase tracking-wider mb-2">{{ 'backOffice.partnerNetwork.myCode' | translate }}</p>
                        <!-- Font size responsive adjustment -->
                        <div class="text-xl sm:text-2xl font-mono font-black tracking-widest mb-4 break-all">{{ myPartnerCode() }}</div>
                        <button (click)="copyCode()" class="bg-white/10 hover:bg-white/20 text-white px-4 py-2 rounded-lg text-sm font-bold transition-colors border border-white/20">
                            <i class="fa-regular fa-copy mr-2"></i> {{ 'backOffice.partnerNetwork.copy' | translate }}
                        </button>
                    </div>
                    <i class="fa-solid fa-user-doctor absolute -bottom-4 -right-4 text-9xl text-white/5"></i>
                </div>

                <div>
                    <h3 class="font-bold text-gray-800 mb-4 flex items-center justify-between flex-wrap gap-2">
                        <span>{{ 'backOffice.partnerNetwork.active' | translate }} (Connected Dispensaries)</span>
                        <span class="bg-slate-100 text-slate-600 text-xs px-2 py-1 rounded-full">{{ connectedPartners().length }} Active</span>
                    </h3>
                    
                    @if(isLoading()) {
                        <div class="text-center py-10 text-slate-500"><i class="fa-solid fa-spinner animate-spin text-2xl"></i> Loading...</div>
                    } @else {
                        <!-- Table Wrapper for Scroll -->
                        <div class="border rounded-lg overflow-x-auto w-full">
                            <table class="min-w-full divide-y divide-gray-200">
                                <thead class="bg-gray-50">
                                    <tr>
                                        <th class="px-4 sm:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase whitespace-nowrap">{{ 'common.name' | translate }}</th>
                                        <th class="px-4 sm:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase whitespace-nowrap">{{ 'backOffice.reports.headers.date' | translate }}</th>
                                        <th class="px-4 sm:px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase whitespace-nowrap">{{ 'common.status' | translate }}</th>
                                    </tr>
                                </thead>
                                <tbody class="bg-white divide-y divide-gray-200">
                                    @for(partner of connectedPartners(); track partner.id) {
                                        <tr>
                                            <td class="px-4 sm:px-6 py-4 whitespace-nowrap">
                                                <div class="font-bold text-gray-900">{{ partner.partner_name }}</div>
                                                <div class="text-xs text-gray-500">
                                                    {{ partner.direction === 'INCOMING' ? ('backOffice.partnerNetwork.incomingReq' | translate) : ('backOffice.partnerNetwork.outgoingReq' | translate) }}
                                                </div>
                                            </td>
                                            <td class="px-4 sm:px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                {{ partner.created_at | date:'mediumDate' }}
                                            </td>
                                            <td class="px-4 sm:px-6 py-4 whitespace-nowrap text-right">
                                                @if(partner.status === 'ACTIVE') {
                                                    <span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">{{ 'backOffice.partnerNetwork.active' | translate }}</span>
                                                } @else if(partner.status === 'REJECTED') {
                                                    <span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-red-100 text-red-800">{{ 'backOffice.partnerNetwork.rejected' | translate }}</span>
                                                } @else {
                                                    <div class="flex items-center justify-end gap-2">
                                                        <span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-yellow-100 text-yellow-800 mr-2">{{ 'backOffice.partnerNetwork.pending' | translate }}</span>
                                                        @if(partner.direction === 'INCOMING') {
                                                            <button (click)="acceptPartner(partner.id)" class="text-xs bg-indigo-600 text-white px-2 py-1 rounded hover:bg-indigo-700">{{ 'backOffice.partnerNetwork.accept' | translate }}</button>
                                                            <button (click)="rejectPartner(partner.id)" class="text-xs bg-white border border-slate-300 text-slate-600 px-2 py-1 rounded hover:bg-slate-50">{{ 'backOffice.partnerNetwork.reject' | translate }}</button>
                                                        }
                                                    </div>
                                                }
                                            </td>
                                        </tr>
                                    } @empty {
                                        <tr><td colspan="3" class="text-center py-8 text-slate-500">{{ 'backOffice.partnerNetwork.empty' | translate }}</td></tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    }
                </div>
            </div>
        } @else {
            <!-- CLIENT VIEW (DISPENSARY) -->
            <div class="max-w-lg mx-auto space-y-6">
                <div class="text-center">
                    <h3 class="text-lg font-bold text-gray-800">{{ 'backOffice.partnerNetwork.connectTitle' | translate }}</h3>
                    <p class="text-gray-500 text-sm">{{ 'backOffice.partnerNetwork.connectDesc' | translate }}</p>
                </div>

                <div class="bg-slate-50 p-6 rounded-xl border border-slate-200">
                    <label class="block text-sm font-medium text-gray-700 mb-2">{{ 'backOffice.partnerNetwork.partnerCode' | translate }}</label>
                    <div class="flex gap-2 flex-col sm:flex-row">
                        <input type="text" [(ngModel)]="partnerCodeInput" placeholder="Place Store ID here..." class="flex-grow border-gray-300 rounded-md shadow-sm focus:ring-emerald-500 focus:border-emerald-500 font-mono text-sm p-2">
                        <button (click)="connectPartner()" [disabled]="!partnerCodeInput() || partnerCodeInput() === myPartnerCode()" class="bg-emerald-600 text-white px-4 py-2 rounded-md hover:bg-emerald-700 font-bold disabled:bg-slate-300 disabled:cursor-not-allowed">
                            {{ 'backOffice.partnerNetwork.connectBtn' | translate }}
                        </button>
                    </div>
                    @if(partnerCodeInput() === myPartnerCode()) {
                        <p class="text-xs text-red-500 mt-2 font-bold">* {{ 'backOffice.partnerNetwork.cannotSelf' | translate }}</p>
                    }
                </div>
                
                 <div>
                    <h4 class="font-bold text-gray-700 mb-2">{{ 'backOffice.partnerNetwork.status' | translate }}</h4>
                     @if(isLoading()) {
                        <div class="text-center text-sm text-slate-500">Loading...</div>
                    } @else {
                         <div class="space-y-2">
                             @for(partner of connectedPartners(); track partner.id) {
                                 <div class="bg-white border rounded-lg p-3 flex justify-between items-center">
                                     <div>
                                         <div class="font-bold text-sm">{{ partner.partner_name }}</div>
                                         <div class="text-xs text-gray-500">{{ partner.status }}</div>
                                     </div>
                                     <div class="text-xs text-slate-400">
                                         {{ partner.created_at | date:'shortDate' }}
                                     </div>
                                 </div>
                             } @empty {
                                 <div class="text-center text-sm text-slate-400 py-4 bg-slate-50 rounded">{{ 'backOffice.partnerNetwork.emptyClient' | translate }}</div>
                             }
                         </div>
                    }
                 </div>

                <div class="bg-white border rounded-lg p-4 flex items-center gap-4 mt-6">
                    <div class="w-12 h-12 rounded-full bg-slate-100 flex items-center justify-center text-slate-400">
                        <i class="fa-solid fa-circle-info text-xl"></i>
                    </div>
                    <div>
                        <p class="font-bold text-gray-800">{{ 'backOffice.partnerNetwork.noteTitle' | translate }}</p>
                        <p class="text-xs text-gray-500">{{ 'backOffice.partnerNetwork.noteDesc' | translate }}</p>
                    </div>
                </div>
            </div>
        }
    </div>
  </div>
</div>

<!-- Confirmation Modal -->
<app-confirmation-modal
  [isOpen]="confirmModalState().isOpen"
  [title]="confirmModalState().title"
  [message]="confirmModalState().message"
  [confirmButtonText]="confirmModalState().confirmButtonText"
  [confirmButtonClass]="confirmModalState().confirmButtonClass"
  (confirm)="onConfirmAction()"
  (cancel)="closeConfirmModal()">
</app-confirmation-modal>
